export default __webpack_public_path__ + "static/Hexagons_Grid_background-4444e63e6786a649f8ed881b280b1c19.svg";